angular.module('unica_approvation_list.approvation_list_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// APPROVATION LIST
		.state('app.approvation_list', {
			url: '/approvation-list',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/approvation-list/templates/approvation-list.html',
					controller: 'ApprovationListBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// APPROVATION LIST LIST
			.state('app.approvation_list.list', {
				url: '/list/:event_id/:invitation_list_id',
				views: {
					'approvationListContent': {
						templateUrl: './modules/approvation-list/templates/list.html',
						controller: 'ApprovationListListController'
					}
				},
				ncyBreadcrumb: {
					label: 'Liste Approvazione',
					parent: function($scope) {
						return 'app.invitation_list.list({event_id:' + $scope.event_id + '})';
					}
				}
			})

			// APPROVATION LIST CREATE
			.state('app.approvation_list.create', {
				url: '/create/:event_id/:invitation_list_id',
				views: {
					'approvationListContent': {
						templateUrl: './modules/approvation-list/templates/create.html',
						controller: 'ApprovationListCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Crea Tipologia Lista',
					parent: 'app.approvation_list.list'
				}
			})

			// APPROVATION LIST EDIT
			.state('app.approvation_list.edit', {
				url: '/edit/:event_id/:invitation_list_id/:id',
				views: {
					'approvationListContent': {
						templateUrl: './modules/approvation-list/templates/edit.html',
						controller: 'ApprovationListEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Lista Approvazione',
					parent: 'app.approvation_list.list'
				}
			})

			// APPROVATION LIST ZM
			.state('app.approvation_list.list_zm', {
				url: '/list-zm',
				views: {
					'approvationListContent': {
						templateUrl: './modules/approvation-list/templates/list-zm.html',
						controller: 'ApprovationListListZmController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Liste Approvazione',
					parent: 'app.dashboard'
				}
			})

			// APPROVATION LIST VIEW ZM
			.state('app.approvation_list.view_zm', {
				url: '/view-zm/:event_id/:invitation_list_id/:id',
				views: {
					'approvationListContent': {
						templateUrl: './modules/approvation-list/templates/view-zm.html',
						controller: 'ApprovationListViewZmController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Compila Lista',
					parent: 'app.approvation_list.list_zm'
				}
			})

			// APPROVATION LIST AM
			.state('app.approvation_list.list_am', {
				url: '/list-am',
				views: {
					'approvationListContent': {
						templateUrl: './modules/approvation-list/templates/list-am.html',
						controller: 'ApprovationListListAmController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Liste Approvazione',
					parent: 'app.dashboard'
				}
			})


			// APPROVATION LIST VIEW AM
			.state('app.approvation_list.view_am', {
				url: '/view-am/:event_id/:invitation_list_id/:id',
				views: {
					'approvationListContent': {
						templateUrl: './modules/approvation-list/templates/view-am.html',
						controller: 'ApprovationListViewAmController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Vedi Lista Approvazione',
					parent: 'app.approvation_list.list_am'
				}
			});


});

